import R from "ramda";
import { BOOTSTRAP_DOCUMENTS_ORDER } from "actions/bootstrap-actions";
import {
  ADD_CATEGORY_TO_FILTER,
  ADD_CURRENCY_TO_FILTER,
  ADD_ENVELOPE_TO_FILTER,
  ADD_PAYMENT_TYPE_TO_FILTER,
  ADD_VENDOR_TO_FILTER,
  CLEAR_EXPORT_TYPE_FILTER,
  REMOVE_CATEGORY_FROM_FILTER,
  REMOVE_CURRENCY_FROM_FILTER,
  REMOVE_ENVELOPE_FROM_FILTER,
  REMOVE_PAYMENT_TYPE_FROM_FILTER,
  REMOVE_VENDOR_FROM_FILTER,
  SET_EXPORT_TYPE_FILTER,
  ADD_START_DATE_TO_FILTER,
  ADD_END_DATE_TO_FILTER,
  ORDER_BY,
  ADD_CARD_NUMBER_TO_FILTER,
  REMOVE_CARD_NUMBER_FROM_FILTER,
  ADD_SEARCH_QUERY_TO_FILTER,
  REMOVE_SEARCH_QUERY_FROM_FILTER,
  UPDATE_SEARCH_QUERY,
  SET_TRASH_VIEW,
  RESET_FILTERS,
  ADD_DOCUMENT_TYPE_TO_FILTER,
  REMOVE_DOCUMENT_TYPE_FROM_FILTER,
  ADD_VIEWED_STATUS_TO_FILTER,
  REMOVE_VIEWED_STATUS_FROM_FILTER,
  SET_FILTERS,
  UPDATE_TOTAL_FILTER,
  REMOVE_NAME_FROM_FILTER,
  UPDATE_NAME,
  ADD_NAME_TO_FILTER
} from "actions/document-filters-actions";
import { CUSTOM_TAB_CREATED } from "actions/custom-tabs-actions";
import {
  addToSelectedCardNumbers,
  addToSelectedCategories,
  addToSelectedCurrencies,
  addToSelectedEnvelopes,
  addToSelectedPaymentTypes,
  addToSelectedVendors,
  removeSelectedCardNumber,
  removeSelectedCategory,
  removeSelectedCurrency,
  removeSelectedEnvelope,
  removeSelectedPaymentType,
  removeSelectedVendor,
  stateForAddSearchQueryToFilter,
  stateForOrderBy
} from "reducers/functions/documents-exports-filters-functions";

export const initialState = {
  endDate: null,
  exportType: null,
  isExports: false,
  isTrash: false,
  lastFourDigits: null,
  name: "",
  processingState: "PROCESSED",
  orderDirection: "DESC",
  orderBy: "uploaded",
  startDate: null,
  searchQueryString: "",
  selectedCardNumbers: [],
  selectedCategories: [],
  selectedCurrencies: [],
  selectedEnvelopes: [],
  selectedName: "",
  selectedPaymentTypes: [],
  selectedSearchQueryString: null,
  selectedVendors: [],
  totalMin: "",
  totalMax: "",
  type: null,
  viewedStatus: ""
};

export const documentFiltersReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_VENDOR_TO_FILTER:
      return addToSelectedVendors(state, action.data.update);
    case REMOVE_VENDOR_FROM_FILTER:
      return removeSelectedVendor(state, action.data.update);
    case ADD_CATEGORY_TO_FILTER:
      return addToSelectedCategories(state, action.data.update);
    case REMOVE_CATEGORY_FROM_FILTER:
      return removeSelectedCategory(state, action.data.update);
    case ADD_PAYMENT_TYPE_TO_FILTER:
      return addToSelectedPaymentTypes(state, action.data.update);
    case REMOVE_PAYMENT_TYPE_FROM_FILTER:
      return removeSelectedPaymentType(state, action.data.update);
    case ADD_CURRENCY_TO_FILTER:
      return addToSelectedCurrencies(state, action.data.update);
    case REMOVE_CURRENCY_FROM_FILTER:
      return removeSelectedCurrency(state, action.data.update);
    case CLEAR_EXPORT_TYPE_FILTER:
      return R.merge(state, { exportType: null });
    case SET_EXPORT_TYPE_FILTER:
      return R.merge(state, { exportType: action.data.update });
    case ADD_ENVELOPE_TO_FILTER:
      return addToSelectedEnvelopes(state, action.data.update);
    case REMOVE_ENVELOPE_FROM_FILTER:
      return removeSelectedEnvelope(state, action.data.update);
    case ADD_START_DATE_TO_FILTER:
      return R.merge(state, { startDate: action.data.update });
    case ADD_END_DATE_TO_FILTER:
      return R.merge(state, { endDate: action.data.update });
    case ORDER_BY:
      return stateForOrderBy(state, action.data.key);
    case BOOTSTRAP_DOCUMENTS_ORDER:
      return R.merge(state, action.data);
    case ADD_CARD_NUMBER_TO_FILTER:
      return addToSelectedCardNumbers(state, action.data.update);
    case REMOVE_CARD_NUMBER_FROM_FILTER:
      return removeSelectedCardNumber(state, action.data.update);
    case ADD_SEARCH_QUERY_TO_FILTER:
      return stateForAddSearchQueryToFilter(state, action.data.update);
    case ADD_VIEWED_STATUS_TO_FILTER:
      return R.merge(state, { viewedStatus: action.data.update });
    case REMOVE_VIEWED_STATUS_FROM_FILTER:
      return R.merge(state, { viewedStatus: "" });
    case REMOVE_SEARCH_QUERY_FROM_FILTER:
      return R.merge(state, { searchQueryString: "", selectedSearchQueryString: null });
    case UPDATE_SEARCH_QUERY:
      return R.merge(state, { searchQueryString: action.data.query });
    case SET_TRASH_VIEW:
      return R.merge(state, { isTrash: action.data.update });
    case ADD_DOCUMENT_TYPE_TO_FILTER:
      return R.merge(state, { type: action.data.update });
    case REMOVE_DOCUMENT_TYPE_FROM_FILTER:
      return R.merge(state, { type: null });
    case UPDATE_TOTAL_FILTER:
      return stateForUpdateTotalFilter(state, action);
    case SET_FILTERS:
      return R.merge(state, action.data.filters);
    case UPDATE_NAME:
      return R.merge(state, { name: action.data.name });
    case ADD_NAME_TO_FILTER:
      return R.merge(state, { selectedName: state.name });
    case REMOVE_NAME_FROM_FILTER:
      return R.merge(state, { name: "", selectedName: "" });
    case RESET_FILTERS:
    case CUSTOM_TAB_CREATED:
      return initialState;
    default:
      return state;
  }
};

const stateForUpdateTotalFilter = (state, action) => {
  if (action.data.type === "min") {
    return R.merge(state, { totalMin: action.data.value });
  }
  return R.merge(state, { totalMax: action.data.value });
};



// WEBPACK FOOTER //
// ./src/js/reducers/document-filters-reducer.js